import { COMPANY } from "@/data/products";
import { Link } from "react-router-dom";

export const Footer = () => {
    return (
        <footer className="bg-ink text-bone py-14 md:py-20" data-testid="site-footer">
            <div className="mx-auto max-w-[1440px] px-6 md:px-10">
                <div className="grid grid-cols-12 gap-8">
                    <div className="col-span-12 md:col-span-5">
                        <div className="flex items-center gap-3">
                            <img
                                src="/assets/logo.png"
                                alt="Mist Paints"
                                className="h-10 w-auto"
                            />
                        </div>
                        <p className="mt-6 max-w-sm text-bone/60">
                            {COMPANY.tagline} Premium coatings engineered in Muscat for interiors,
                            exteriors, wood and metal.
                        </p>
                    </div>

                    <div className="col-span-6 md:col-span-3">
                        <div className="font-mono text-[10px] uppercase tracking-widest text-bone/40 mb-4">
                            Navigate
                        </div>
                        <ul className="space-y-2 text-sm">
                            <li><Link className="hover:text-brand-yellow" to="/">Home</Link></li>
                            <li><Link className="hover:text-brand-yellow" to="/products">Products</Link></li>
                            <li><Link className="hover:text-brand-yellow" to="/catalogue">Catalogue</Link></li>
                            <li><Link className="hover:text-brand-yellow" to="/about">About</Link></li>
                            <li><Link className="hover:text-brand-yellow" to="/contact">Contact</Link></li>
                        </ul>
                    </div>

                    <div className="col-span-6 md:col-span-4">
                        <div className="font-mono text-[10px] uppercase tracking-widest text-bone/40 mb-4">
                            Reach us
                        </div>
                        <ul className="space-y-2 text-sm text-bone/80">
                            <li>{COMPANY.phone}</li>
                            <li>
                                <a href={`mailto:${COMPANY.email}`} className="hover:text-brand-yellow">
                                    {COMPANY.email}
                                </a>
                            </li>
                            <li className="pt-1">
                                {COMPANY.addressLines.map((line) => (
                                    <div key={line}>{line}</div>
                                ))}
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-14 pt-6 border-t border-bone/15 flex flex-wrap items-center justify-between gap-4 text-xs font-mono uppercase tracking-widest text-bone/40">
                    <div>© {new Date().getFullYear()} Mist Paints · All rights reserved</div>
                    <div className="flex flex-wrap gap-6 items-center">
                        <a
                            href="/downloads/mist-paints-cpanel.zip"
                            className="hover:text-brand-yellow underline decoration-dotted underline-offset-4"
                            data-testid="footer-download"
                        >
                            Download site ↓ cPanel-ready
                        </a>
                        <span>Made in Oman · Rusayl Industrial Estate</span>
                    </div>
                </div>
            </div>
        </footer>
    );
};
